export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video'
}

export interface MediaFile {
  file: File;
  preview: string;
  type: MediaType;
  progress: number;
  uploadedUrl?: string;
  error?: string;
}

export interface MediaVariant {
  url: string;
  format: string;
  type: 'original' | 'thumbnail';
}

export interface MediaItem {
  type: MediaType;
  variants: MediaVariant[];
}

export interface MediaUploadResult {
  url: string;
  type: MediaType;
  metadata: {
    width?: number;
    height?: number;
    duration?: number;
  };
}

export interface MediaUploadProgress {
  id: string;
  progress: number;
  status: 'uploading' | 'completed' | 'error';
  error?: string;
}

export interface MediaUploadOptions {
  maxSize?: number;
  acceptedTypes?: string[];
  generateThumbnail?: boolean;
  compressBeforeUpload?: boolean;
}
